var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("HeaderNavs", {
    attrs: { loading: _vm.loading, data: _vm.data, twoRow: true },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }